export default __webpack_public_path__ + "static/media/normal-level-preview.cce9380e.svg";